import {logForCrashlytics} from 'src/Utils/fireUtils';

export const formatDailyChallenges = (challenges) => {
  logForCrashlytics('formatDailyChallenges fired in dataFormatter.js');
  return challenges?.map?.((challenge) => {
    return {
      category: challenge.category,
      challenge_id: challenge.challenge_id,
      completed: Boolean(parseInt(challenge.completed)),
      completed_success: Boolean(parseInt(challenge.completed_success)),
      coin_value: parseInt(challenge.coin_value),
      task: challenge.task,
      challenge_medium: challenge.challenge_medium,
      difficulty: challenge.difficulty,
      scheduled_id: parseInt(challenge.scheduled_id),
      name: challenge.name,
      type: challenge.type,
      lr_app_challenge_completion_id:
        challenge.lr_app_challenge_completion_id || false,
      user_id: challenge.user_id,
      photo_url: challenge.photo_url,
      shareUUID: challenge.share_UUID || null,
    };
  });
};
